export enum DescriptionMode {
  'visible' = 'visible',
  'hidden' = 'hidden',
  'toggable' = 'toggable',
}
